import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronHollowUp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M30 20C30 22.206 28.206 24 26 24C24.932 24 23.927 23.584 23.172 22.828L16 15.656L8.829 22.828C8.073 23.584 7.069 24 6 24C3.794 24 2 22.206 2 20C2 18.932 2.416 17.927 3.171 17.172L13.171 7.17198C13.926 6.41698 14.931 6.00098 16 6.00098C17.069 6.00098 18.073 6.41698 18.828 7.17198L28.828 17.172C29.584 17.928 30 18.932 30 20.001V20ZM4 20C4 21.103 4.897 22 6 22C6.534 22 7.036 21.792 7.414 21.414L15.292 13.535C15.683 13.145 16.316 13.145 16.706 13.535L24.585 21.414C24.963 21.792 25.465 22 25.999 22C27.102 22 27.999 21.103 27.999 20C27.999 19.466 27.791 18.964 27.413 18.586L17.413 8.58598C17.036 8.20798 16.533 7.99998 15.999 7.99998C15.465 7.99998 14.962 8.20798 14.585 8.58598L4.585 18.586C4.207 18.964 3.999 19.466 3.999 20H4Z" />
	</svg>
);

export default ChevronHollowUp;
